const DivideOperator = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" width="13" height="13">
            <path fill="none" stroke="currentColor" strokeLinecap="square" d="M2.5 6.5h9"></path>
            <circle fill="currentColor" cx="7" cy="3" r="1"></circle>
            <circle fill="currentColor" cx="7" cy="10" r="1"></circle>
        </svg>
    )
}
export default DivideOperator